exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "footer .copyright-text{width:320px;display:inline-block}footer .privacy-link{position:relative;padding-right:77px}footer .privacy-link img{opacity:.6;position:absolute;margin-top:2px;margin-left:3px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/postcss-loader!../~/sass-loader!./components/footer.scss
// module id = 593
// module chunks = 0